export function getActionableByCode(code, defaultActionable) {
  const codeActionables = new Map([
    ['13111305', 'USER_FIX'],
    ['13110921', 'USER_FIX'],
    ['12111305', 'USER_FIX'],
    ['13110916', 'USER_FIX'],
  ]);
  return codeActionables.get(code) || defaultActionable;
}
